<template>
  <div class="vue-county-admin-wrap">
    <div>
      <div
      class="add-new-button-container"
      v-if="!createCountyFormVisible">
      <span
      class="add-new-button"
      @click="showCreateCountyForm">+</span><span class="add-new-button-label">Add new county</span>
      </div>
      <b-spinner v-if="!counties || !counties.length" class="spinner"></b-spinner>
      <div v-if="counties && !createCountyFormVisible">
        <header v-if="!selectedCounty && !createCountyFormVisible">Edit County</header>
        <select-county-dropdown
        :countySelected="onCountySelected"
        :counties="counties"></select-county-dropdown>
      </div>
      <div>
        <div>
          <create-county-form
          v-if="createCountyFormVisible"
          :getAllCounties="getAllCounties"
          :hide="hideCreateCountyForm"
          :createCountySuccess="onCreateCountySuccess"></create-county-form>
        </div>
        <template v-if="countyCreateSuccessMessage">
          <div
          class="county-create-success-message"
          v-bind:class="{fade: countyCreateSuccessMessageFade}">&#10003;&nbsp;{{countyCreateSuccessMessage}}</div>
        </template>
        <header v-if="selectedCounty">Edit County: {{selectedCounty.name}}</header>
        <edit-county-form
        v-if="selectedCounty"
        :selectedCounty="selectedCounty"
        :getAllCounties="getAllCounties"
        :destroySelectedCounty="destroySelectedCounty"
        :countyUpdateSuccessMessage="onCountyUpdateSuccessMessage"></edit-county-form>
      </div>
      <template v-if="countyUpdateSuccessMessage">
        <div
        class="county-update-success-message"
        v-bind:class="{fade: countyUpdateSuccessMessageFade}">&#10003;&nbsp;{{countyUpdateSuccessMessage}}</div>
      </template>
    </div>
  </div>
</template>

<script>
import API from "@/services/api";
import CreateCountyForm from "./CreateCountyForm";
import EditCountyForm from "./edit-county/EditCountyForm";
import SelectCountyDropdown from "./edit-county/SelectCountyDropdown";

export default {
  name: 'CountyAdmin',
  components: {
    CreateCountyForm,
    EditCountyForm,
    SelectCountyDropdown
  },
  data() {
    return {
      counties: undefined,
      selectedCounty: undefined,
      createCountyFormVisible: undefined,
      countyCreateSuccessMessage: undefined,
      countyCreateSuccessMessageFade: undefined,
      countyUpdateSuccessMessage: undefined,
      countyUpdateSuccessMessageFade: false
    }
  },
  async created() {
    this.getAllCounties();
  },
  methods: {
    showCreateCountyForm() {
      this.selectedCounty = undefined;
      this.createCountyFormVisible = true;
    },
    hideCreateCountyForm() {
      this.createCountyFormVisible = undefined;
    },
    destroySelectedCounty() {
      this.selectedCounty = undefined;
      this.getAllCounties();
    },
    onCountySelected(county) {
      this.selectedCounty = JSON.parse(JSON.stringify(county));
    },
    onCreateCountySuccess(message) {
      this.hideCreateCountyForm();
      this.countyCreateSuccessMessage = message;
      setTimeout(() => this.countyCreateSuccessMessageFade = true, 3000);
      setTimeout(() => {
        this.countyCreateSuccessMessage = undefined;
        this.countyCreateSuccessMessageFade = false
      }, 5000);
    },
    onCountyUpdateSuccessMessage(message) {
      this.countyUpdateSuccessMessage = message;
      setTimeout(() => this.countyUpdateSuccessMessageFade = true, 3000);
      setTimeout(() => {
        this.countyUpdateSuccessMessage = undefined;
        this.countyUpdateSuccessMessageFade = false
      }, 5000);
    },
    async getAllCounties() {
      this.counties = undefined;

      try {
        API.GetCounties().then(counties => {
          this.counties = counties || undefined;
          this.$forceUpdate();
        });
      } catch (err) {
        console.log("Unable to fetch counties");
        console.log(err);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../../assets/css/partials/_variables.scss";

.vue-county-admin-wrap{
  position: relative;
  min-height: 70px;

  .create-county-button-wrap{
    position: absolute;
    top: 0;
    right: 0;
  }

  header{
    margin: 20px 0 20px 5px;
    font-weight: $bold;
    color: $black;
  }

  .county-create-success-message,
  .county-update-success-message{
    margin-top: 20px;
    font-weight: bold;
    color: green;
    transition: all 3s ease;

    &.fade{
      opacity: 0;
    }
  }
}
</style>
